// Zedit homepage content + product info
export const zeditAudiences = [
  'For DeFi protocols',
  'For DeFAI protocols',
  'For Infrastructure protocols',
  'For DEXs',
  'For CEXs',
  'For Web3 wallet companies',
  'For Account Abstraction companies',
  'For liquidity providers',
  'For market makers',
  'For founders building serious products',
];

export const zeditChannels = [
  'Through content marketing',
  'Through B2B partnerships',
  'Through B2B integrations',
  'Through grants',
  'Through events',
  'Through KOL strategy',
  'Through acquisitions',
  'Through cost-efficient marketing & budgeting',
];

export const zeditStats = [
  { value: '40+', label: 'Web3 protocols served' },
  { value: '$5M+', label: 'In ecosystem grants surfaced' },
  { value: '1,000+', label: 'Vetted KOLs in network' },
  { value: '6mo→1d', label: 'BD compressed via events' },
];

export const zeditProducts = [
  {
    slug: 'layerseek',
    brandClass: 'brand-layerseek',
    accent: 'rgb(218, 255, 1)',
    accentInk: 'rgb(95, 110, 0)',
    eyebrow: 'Live Events',
    name: 'LayerSeek',
    tagline: 'Get 6 months of BD done in a single day.',
    description:
      'A virtual summit where DeFi protocols meet other DeFi protocols. Real venue, real conversations, AI matchmaking that actually understands what you ship.',
    bullets: [
      'Virtual venue with 9 floors and live booths',
      'AI matchmaking based on what you build',
      'Sponsor tiers from $997 to $8,497',
    ],
    cta: { label: 'Explore LayerSeek', href: '/layerseek' },
    secondaryCta: { label: 'Get tickets', href: '/layerseek#pricing' },
    badge: 'November 20, 2026',
  },
  {
    slug: 'clips',
    brandClass: 'brand-clips',
    accent: 'rgb(239, 68, 68)',
    accentInk: 'rgb(180, 30, 30)',
    eyebrow: 'AI Video',
    name: 'Clips',
    tagline: 'Long videos, short clips, viral reach. In one click.',
    description:
      'AI takes your podcasts, AMAs, and Twitter Spaces, finds the best moments, captions them, and ships ready-to-post short clips for X, TikTok, and YouTube Shorts.',
    bullets: [
      'Auto-detect viral-worthy moments',
      'AI captions, framing, and effects',
      '1-click share to X, TikTok, Shorts',
    ],
    cta: { label: 'Try Clips', href: '/clips' },
    secondaryCta: { label: 'Open the app', href: 'https://clips.zedit.io', external: true },
    badge: 'Live now',
  },
  {
    slug: 'truekol',
    brandClass: 'brand-truekol',
    accent: 'rgb(168, 85, 247)',
    accentInk: 'rgb(120, 50, 200)',
    eyebrow: 'KOL Network',
    name: 'TrueKOL',
    tagline: "Stop overpaying for KOLs you can't verify.",
    description:
      "A vetted directory of crypto KOLs with real engagement data, true collaboration costs, and direct contacts. Skip the agencies, skip the inflated invoices.",
    bullets: [
      '1,000+ vetted KOLs across crypto Twitter',
      'Verified true pricing · no markup',
      'Direct contact, performance history',
    ],
    cta: { label: 'See TrueKOL', href: '/truekol' },
    secondaryCta: { label: 'Request access', href: '/truekol#access' },
    badge: 'Invite only',
  },
];

export const zeditFAQ = [
  {
    q: 'What is Zedit?',
    a: "Zedit is a product suite focused on tangible growth for Web3 companies. We build software and run programs across events, KOL strategy, and AI content · all with one goal: deals shipped, not decks shipped.",
  },
  {
    q: 'Who is Zedit for?',
    a: 'DeFi protocols, infrastructure teams, DEXs, CEXs, wallet companies, market makers, liquidity providers · and the founders behind them. If you\'re building a serious Web3 product and you need real growth, you\'re our user.',
  },
  {
    q: 'Are these products separate or one platform?',
    a: 'Each product (LayerSeek, Clips, TrueKOL) stands on its own and can be used independently. They share an ecosystem and complement each other · sponsors of LayerSeek get perks across the suite.',
  },
  {
    q: 'How do I work with Zedit on a custom growth program?',
    a: "Reach out at hi@zedit.io. We work directly with protocol teams who want a tailored mix of content, KOLs, partnerships, and event presence · without rebuilding the wheel.",
  },
  {
    q: 'Where do I learn more about LayerSeek?',
    a: 'LayerSeek has its own dedicated page at /layerseek with the full agenda, sponsor tiers, virtual venue tour, and ticket purchase flow.',
  },
];
